import React, { forwardRef } from "react";
import { makeStyles, Container } from "@material-ui/core";
import BoardListGroup from "../../../components/MainComponent/BoardComponent/BoardListGroup";
import BoardSerchResult from "../../../components/MainComponent/BoardComponent/BoardSerchResult";

const useStyles = makeStyles((theme) => ({
  BoardTop: {
    paddingTop: "8rem",
    paddingBottom: "4rem",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "4rem",
      paddingBottom: "2rem",
    },
  },
}));

interface BoardSearchContainerProps {
  //   children: React.ReactNode | null | string | undefined;
  match: any;
  history: any;
}

function BoardSearchContainer({ match, history }: BoardSearchContainerProps) {
  const classes = useStyles();

  return (
    <Container className={classes.BoardTop}>
      {/* <BoardListGroup match={match} history={history} /> */}
      <BoardSerchResult match={match} history={history} />
    </Container>
  );
}

export default BoardSearchContainer;
